export const USER_PROFILE_API_ROUTES = {
    USER_DETAILS:'user/userDetails',
    COURSE_PREFERNCE:'user/coursePreferances',
    PASSWORD:'user/password',
    BOARD_LIST:'user/boardList',
    CLASS_LIST:'user/classList',
    SUBJECT_LIST:'user/subjectList',
    EDUCATIONAL_INTEREST:'user/educationInterestList',
    UPDATE_COURSE_PREFER:'user/coursePreferances',
    LANGUAGE_LIST:'user/languageList',
    UPDATE_LANGUAGE:'user/language'
}